/** @format */

import {styled, Theme} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

import {DiffColor} from 'components/charts/multiline-chart/model/tooltip';

interface CompactProps {
  isCompact?: boolean;
}

export const Root = styled(Box)(() => ({
  position: 'relative',
}));

export const Content = styled(Box, {
  shouldForwardProp: prop => prop !== 'isCompact',
})<CompactProps>(({theme, isCompact}) => ({
  width: isCompact ? 'auto' : '392px',
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(1),
}));

interface BgProps {
  bgColor: string;
}

export const BgBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'bgColor',
})<BgProps>(({bgColor}) => ({
  position: 'absolute',
  zIndex: 0,
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  backgroundColor: bgColor,
  borderRadius: '4px',
  opacity: 0.2,
}));

export const RegularText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.inverseOnSurface,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

const getSubTextColor = (theme: Theme, customColor?: DiffColor): string | undefined => {
  switch (customColor) {
    case 'green': {
      return theme.palette.semantic_dark?.good.main;
    }
    case 'red': {
      return theme.palette.semantic_dark?.bad.main;
    }
    default: {
      return theme.palette.semantic_dark?.surface.inverseOnSurface;
    }
  }
};

interface SubTextProps {
  customColor?: DiffColor;
}

export const SubText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'customColor',
})<SubTextProps>(({theme, customColor}) => ({
  color: getSubTextColor(theme, customColor),
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '14px',
}));

export const OpacitySubText = styled(SubText)(() => ({
  opacity: 0.5,
}));

export const RowBox = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(4),
  width: '100%',
}));

export const ExtraRowsBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const LabelBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const DeltaBox = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

export const ForecastBox = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

export const ForecastColumnLeft = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
}));

export const ForecastColumnRight = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const ForecastAverageText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.inverseOnSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const ValueBox = styled(Box)(() => ({
  p: {
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },
}));
